import React, { useState } from 'react'
import './forgotPassword.css'
import { useForm } from 'react-hook-form'
import { Link } from 'react-router-dom'
import logo from "../../assets/Aspom-Logo.png"
import Loader from '../../components/loader/Loader'
import {sendForgotPass} from '../../api'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';

// Create a SweetAlert2 instance with React integration
const MySwal = withReactContent(Swal);

const ForgotPassword = () => {
    const [isLoading, setIsLoading] = useState(false)
    const {
        register,
        handleSubmit,
        formState:{errors},
        reset
    } = useForm({
        mode: 'onChange'
    })

    const handleForgotPassword = async (data) => {
        setIsLoading(true)
        try {
            const res = await sendForgotPass(data)
            if(res?.success){
                reset()
                MySwal.fire({
                    icon: 'success',
                    text: res?.message,
                    showConfirmButton: false,
                    timer: 3000
                });
            }else{
                MySwal.fire({
                    icon: 'error',
                    text: res?.message,
                    showConfirmButton: false,
                    timer: 3000
                });
            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            console.log(error)
            setIsLoading(false)
            MySwal.fire({
                icon: 'error',
                text: "There's an error processing your request, Try again",
                showConfirmButton: false,
                timer: 3000
            });
        }
    }
  return (
    <section className='forgot__page'>
        <div className="forgot__container">
            <div className="forgot__content-heading">
                <div className="forgot__content-text">
                    <h1 className="forgot__form-title">
                        Forgot Password
                    </h1>
                    <span className="forgot__form-subtitle">
                        Enter your email to reset your password
                    </span>
                </div>
                <img src={logo} alt="" className="forgot__content-logo" />
            </div>


            <form className="forgot__form" 
            onSubmit={handleSubmit(handleForgotPassword)}
            >
                <div className="forgot__form-data flex">
                    <div className='forgot__form-div'>
                        <div className="forgot__form-field">
                            <i class='bx bx-envelope forgot__form-icon'></i>
                            <label htmlFor="email" className='forgot__form-label'>
                                Email Address
                            </label>
                            <input type='email' 
                            name='email' 
                            className='forgot__form-input'
                            {...register('email',{required: 'This field is required'})}
                            />
                        </div>
                        {errors.email && <span className="forgot__form-error">
                        {errors.email.message}</span>}
                    </div>
                    
                </div>

                <Link to='/auth' className='forgot__form-link'>
                    Remeber password ? Login
                </Link>
                {isLoading ? <Loader/> : <button
                type='submit'
                className='forgot__form-button'>Submit</button>}
            </form>

        </div>
    </section>
  )
}

export default ForgotPassword